import { FormHelperText, Grid } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import styles from "./styles";
import Commons from "@utils/utility";
import { axiosFetch, Headers } from "@utils/axiosUtil";
import useStyles from "@hooks/useStyle";
import { MvFileUploadPropsInterface } from "@mv-components/types";
import { Typography } from "..";
import lang from "core/constants/lang";

const FileUpload = (props: MvFileUploadPropsInterface) => {
	const { onChange, itemKey, value, disabled, label, extraClass, description, uploadUrl, fileTypeAccept } = props;

	const { classes, cx } = useStyles(styles) as any;

	const handleDrag = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDrop = (e: any) => {
		e.preventDefault();
		e.stopPropagation();
		if (e.dataTransfer.files?.[0]) {
			onChange({ event: { target: { value: e.dataTransfer.files[0] } }, itemKey });
		}
	};

	const handleChange = (e: any) => {
		e.preventDefault();
		if (e.target.files?.[0]) {
			if (uploadUrl) {
				const formData = new FormData();
				formData.append("imageFile", e.target.files?.[0]);
				axiosFetch
					.post(String(uploadUrl), formData, {
						// config: { noLoader: false },
						headers: Headers.multipart,
						onUploadProgress: (progressEvent) => {
							// TODO[A]: handle progress
							// console.log('progressEvent', progressEvent);
							// // let { progress } = this.state;
							// // progress = (progressEvent.loaded / progressEvent.total) * 100;
							// // this.setState({ progress });
						},
					})
					.then((res) => {
						if (res.data?.data?.s3Url) {
							onChange({ event: { target: { value: res.data?.data?.s3Url } }, itemKey });
						} else {
							onChange({ event: { target: { value: "" } }, itemKey });
						}
					})
					.catch(() => {
						// TODO[A]: handle error
						onChange({ event: { target: { value: "" } }, itemKey });
						// onChange(itemKey)({ target: { value: "" } });
					});
			} else {
				onChange({ event: { target: { value: e.target.files[0] } }, itemKey });
			}
		}
	};

	const deleteFile = (e: any) => {
		e.preventDefault();
		onChange({ event: { target: { value: "" } }, itemKey });
	};

	return (
		<div className={disabled ? classes.disabled : ""}>
			{label && <Typography className={classes.t14}>{label}</Typography>}
			{!value && <input type="file" accept={fileTypeAccept} id={itemKey} hidden onChange={handleChange} />}
			<label
				htmlFor={itemKey}
				onDrop={handleDrop}
				onDragEnter={handleDrag}
				onDragLeave={handleDrag}
				onDragOver={handleDrag}
			>
				<Grid
					container
					display="flex"
					direction="column"
					alignItems="center"
					justifyContent="center"
					gap="7px"
					className={cx(
						classes.root,
						classes.cursorPointer,
						Commons.isError(props) ? classes.borderErrorColor : "",
						classes[extraClass?.root]
					)}
				>
					{value && typeof value !== "string" ? (
						<>
							<DescriptionIcon className={classes.colorLightPurple} />
							<Typography className={classes.t14}>{value?.name}</Typography>
							<Typography className={classes.colorMain} onClick={deleteFile}>
								Delete file
							</Typography>
						</>
					) : (
						<>
							<DescriptionIcon className={classes.colorLightPurple} />
							<Typography className={classes.t14}>
								{lang.DRAG_TEXT}
								<span className={classes.colorMain}>{lang.BROWSE}</span>
							</Typography>
							{!!description && (
								<Typography className={cx(classes.t14, classes.cautionLabel)}>{description}</Typography>
							)}
						</>
					)}
				</Grid>
			</label>
			{Commons.getHelperTxt(props) ? (
				<FormHelperText className={classes.radioErrLabel} error={Commons.isError(props)}>
					{Commons.getHelperTxt(props)}
				</FormHelperText>
			) : null}
		</div>
	);
};

export default FileUpload;
